// tslint:disable
export enum LocationPurposeType {
    /**
     * @description UNKNOWN
     */
    UNKN = 0,
    /**
     * @description CORPORATE HEADQUARTERS
     */
    HDQTR = 1,
    /**
     * @description SALES OFFICE
     */
    SALE = 2,
    /**
     * @description RESIDENTIAL ADDRESS
     */
    HOME = 3,
    /**
     * @description WORK ADDRESS
     */
    WORK = 4,
    /**
     * @description SEASONAL ADDRESS
     */
    SEAS = 5,
    /**
     * @description MAILING ADDRESS
     */
    MAIL = 6,
    /**
     * @description BILLING ADDRESS
     */
    BILL = 7,
    /**
     * @description SHIPPING ADDRESS
     */
    SHIP = 8,
}
